<template>
	<div style="padding: 10px;">
		<el-row :gutter="20">
			<el-col :span="6">
				<el-input clearable placeholder="按角色名称查询" v-model="searchInfo.name">
					<template slot="prepend">用户名称</template>
				</el-input>
			</el-col>
			<el-col :span="6">
				<el-select style="width: 100%;" filterable clearable  v-model="searchInfo.id" placeholder="请选择校区">
					<el-option v-for="item in orgList" :key="item.id" :label="item.name" :value="item.id"> </el-option>
				</el-select>
			</el-col>
			<el-col :span="12"> 
				<div style="min-width: 300px;">
					<el-button type="primary" @click="searchSysRole" icon="el-icon-search">搜索</el-button>
					<el-button  icon="el-icon-refresh" @click="clearSearch">重置</el-button>
					<el-button type="primary" icon="el-icon-plus" @click="addRole">新增</el-button>
				</div>
			</el-col>
		</el-row>
		<div >
			<div style="width: 37%;float: left;margin-top: 10px;margin-right: 10px;">
				<div>
					<el-table border highlight-current-row :data="sysRoleList" style="width: 100%"  max-height="700" @row-click="rowSelected">
					    <el-table-column fixed="left" prop="name" label="角色名称" align="center"></el-table-column>
						<el-table-column fixed="left" prop="orgname" label="所属组织" align="center"></el-table-column>
						<el-table-column fixed="right" prop="op" label="操作" width="150" align="center">
							<template slot-scope="scope">
								<a @click="goSysRoleDetail(scope.$index, scope.row)" title="详情" style="display:inline-block;cursor:pointer;color: #409EFF;">
									<i class="el-icon-Stall">详情</i>
								</a>
								<a @click.stop="deleteRoleDetail(scope.$index, scope.row)" title="删除" style="display:inline-block;cursor:pointer;color: #F56C6C;margin-left: 20px;">
									<i class="el-icon-Stall">删除</i>
								</a>
							</template>
						</el-table-column>
					</el-table>
				</div>
				<div style="text-align: center;">
					<el-pagination background layout="total, prev, pager, next, sizes" :page-sizes="[10, 20, 50]" :current-page="param.page"
						:page-size="param.pagenum" :total="roleTotal" @size-change="handleSizeChange" @current-change="handleCurrentChange"> </el-pagination>
				</div>
			</div>
			<div style="width: 20%;float: left;margin-top: 10px;margin-left: 10px;">
				<div style="display: flex;justify-content: center;align-items: center;">角色菜单权限</div>
				<div style="text-align: center;margin-top: 10px;">
					<el-button v-show="!menuedit" size="mini" type="primary" @click="menuedit = true">修改</el-button>
					<el-button v-show="menuedit" size="mini" plain @click="menuedit = false">取消</el-button>
					<el-button v-show="menuedit" size="mini" type="primary" @click="saveRoleMenus">保存</el-button>
				</div>
				<div style="margin-top: 10px;">
					<el-tree ref="menutree" :data="allMenuTree" check-strictly show-checkbox node-key="id" default-expand-all
						:default-checked-keys="selectedMenus" :props="menuProps" :expand-on-click-node="false">
					</el-tree>
				</div>
			</div>
			<div style="width: 37%;float: right;margin-top: 10px;margin-left: 10px;margin-right: 10px;">
				<div style="display: flex;justify-content: center;align-items: center;">角色组织权限</div>
				<div style="text-align: center;margin-top: 10px;">
					<el-button v-show="!orgedit" size="mini" type="primary" @click="orgedit = true">修改</el-button>
					<el-button v-show="orgedit" size="mini" plain @click="orgedit = false">取消</el-button>
					<el-button v-show="orgedit" size="mini" type="primary" @click="saveRoleOrgs">保存</el-button>
				</div>
				<div style="margin-top: 10px;border: 1px solid #e1e1e1;max-height: 600px;overflow: auto;">
					<div >
						<div style="width: 80px;float: left;margin-left: 24px;">
							<el-checkbox v-model="allSelected.org" @change="allBoxChange(1,$event)">全选</el-checkbox>
						</div>
						<div style="width: 60px;float: right;">
							<el-checkbox v-model="allSelected.set" @change="allBoxChange(2,$event)">全选</el-checkbox>
						</div>
						<div style="width: 62px;float: right;margin-right: 20px;">
							<el-checkbox v-model="allSelected.control" @change="allBoxChange(3,$event)">全选</el-checkbox>
						</div>
						<div style="width: 62px;float: right;margin-right: 20px;">
							<el-checkbox v-model="allSelected.read" @change="allBoxChange(4,$event)">全选</el-checkbox>
						</div>
						<div style="clear: both;"></div>
					</div>
					<el-tree ref="orgtree" :data="allOrgTree" check-strictly show-checkbox node-key="id" default-expand-all
						:default-checked-keys="selectedOrgs" :props="orgProps" :expand-on-click-node="false">
						<span class="custom-tree-node" slot-scope="{ node, data }">
						    <span>{{ node.label }}</span>
						    <span>
								<el-checkbox v-model="data.canread" >查看</el-checkbox>
						        <el-checkbox v-model="data.cancontroll" >控制</el-checkbox>
						        <el-checkbox v-model="data.canset" >设置</el-checkbox>
						    </span>
						</span>
					</el-tree>
				</div>
			</div>
			<div style="clear: both;"></div>
		</div>
		<el-dialog @close="refrashData" :destroy-on-close="true" :title="detailTitle" width="70%" :visible.sync="detailShow">
			<RoleDetail @needRefrash="needRefrash" :add="isadd" :orgList="orgList" :selectedrole="selectset"></RoleDetail>
		</el-dialog>
	</div>
</template>

<script>
	//import dayjs from 'dayjs'
	import { queryRolesByPage, querySysRoleMenus,querySysRoleOrgs, 
		querySysMenuTree, queryAllOrgTree, deleteSysRole, updateSysRoleMenus,
		updateSysRoleOrgs, queryAllOrg } from '/static/apiUrl.js'
	import RoleDetail from './roledetail'
	export default {
		name : 'SysRole',
		data() {
			return {
				detailShow: false,
				editok : false,
				menuedit : false,
				orgedit : false,
				isadd : false,
				detailTitle: '角色详情',
				selectset: null,	
				searchInfo:{
					name: '',
					id : '',
				},
				selectedroleid : '',
				allOrgTree : [],
				allMenuTree : [],
				selectedOrgs : [],
				selectedMenus : [],
				menuProps : {
					children: 'children',
					label: 'name'
				},
				orgList : [],
				orgProps : {
					children: 'children',
					label: 'name'
				},
				param : {
					page : 1,
					pagenum : 10,
				},
				roleTotal : 0,
				sysRoleList : [],
				allSelected: {
					org : false,
					read : false,
					control : false,
					set : false
				},
				//lastorgids : [], //前一次点击的角色获取到的组织id列表，用于清空组织权限的checkbox
				/* orgtreePro : {
					checkStrictly: true,
					value : "id",
					label : "name",
					children : "children"
				} */
			}
		},
		mounted() {
			this.initData()
			this.queryRoleList()
		},
		components: {
			RoleDetail,
		},
		methods: {
			allBoxChange(type,value){
				if(1 == type){ //org
					this.selectedOrgs = []
					if(true == value){
						this.orgList.forEach((item) => {
							this.selectedOrgs.push(item.id)
						})
						this.$refs.orgtree.setCheckedKeys(this.selectedOrgs,true);
					}else{
						this.$refs.orgtree.setCheckedKeys(this.selectedOrgs);
					}
				}else if(2 == type){ // set
					this.orgList.forEach((item) => {
						let checknode = this.$refs.orgtree.getNode(item.id)
						//checknode.data.canread = value
						//checknode.data.cancontroll = value
						checknode.data.canset = value
					})
				}else if(3 == type){ // control
					this.orgList.forEach((item) => {
						let checknode = this.$refs.orgtree.getNode(item.id)
						//checknode.data.canread = value
						checknode.data.cancontroll = value
						//checknode.data.canset = value
					})
				}else if(4 == type){ // read
					this.orgList.forEach((item) => {
						let checknode = this.$refs.orgtree.getNode(item.id)
						checknode.data.canread = value
						//checknode.data.cancontroll = value
						//checknode.data.canset = value
					})
				}
			},
			handleSizeChange(val){
				console.log(val);
				this.param.pagenum = val;
				this.queryRoleList()
			},
			handleCurrentChange(val){
				console.log(val);
				this.param.page = val
				this.queryRoleList()
			},
			initData() {
				this.allOrgTree = []
				this.allMenuTree = []
				queryAllOrgTree().then(res => {
					if(0 == res.code){
						this.allOrgTree = res.datas
					}
				})
				querySysMenuTree().then(res => {
					if(0 == res.code){
						this.allMenuTree = res.datas
					}
				})
				this.orgList = []
				queryAllOrg().then(res => {
					if(0 == res.code){
						res.datas.forEach((org) => {
							//if("XQ" == org.type){
								this.orgList.push(org)
							//}
						})
					}
				})
			},
			searchSysRole(){
				this.param.page = 1
				this.sysRoleList = []
				this.queryRoleList()
			},
			clearSearch(){
				this.searchInfo.name = ''
				this.searchInfo.id = ''
				this.param.page = 1
				this.queryRoleList()
			},
			queryRoleList(){
				this.sysRoleList = []
				queryRolesByPage({
					name : this.searchInfo.name,
					oid : this.searchInfo.id,
					pagenum : this.param.page,
					pagesize : this.param.pagenum
				}).then(res => {
					//console.log(res)
					if(0 == res.code){
						this.roleTotal = res.datas.totalnum
						res.datas.data.forEach((set) => {
							this.sysRoleList.push(set)
						})
					}
				})
			},
			rowSelected(row, column, event){
				//先清空上次的组织权限的checkbox
				this.selectedOrgs.forEach((item) => {
					let checknode = this.$refs.orgtree.getNode(item)
					checknode.data.canread = false
					checknode.data.cancontroll = false
					checknode.data.canset = false
				})
				//清空tree的选中
				this.selectedOrgs = []
				this.selectedMenus = []
				this.$refs.menutree.setCheckedKeys(this.selectedMenus);
				this.$refs.orgtree.setCheckedKeys(this.selectedOrgs);
				this.selectedroleid = row.id
				querySysRoleMenus({rid : this.selectedroleid}).then(res => {
					if(0 == res.code){
						res.datas.forEach((it) => {
							this.selectedMenus.push(it.id)
						})
						//console.log(this.selectedMenus)
						this.$refs.menutree.setCheckedKeys(this.selectedMenus,true);
					}
				})
				querySysRoleOrgs({rid : this.selectedroleid}).then(res => {
					if(0 == res.code){
						res.datas.forEach((it) => {
							this.selectedOrgs.push(it.id)
							let read = false
							let control = false
							let set = false
							if(it.roletype.indexOf("read") > -1){
								read = true
							}
							if(it.roletype.indexOf("control") > -1){
								control = true
							}
							if(it.roletype.indexOf("set") > -1){
								set = true
							}
							let checknode = this.$refs.orgtree.getNode(it.id)
							checknode.data.canread = read
							checknode.data.cancontroll = control
							checknode.data.canset = set
							console.log(checknode)
						})
						this.$refs.orgtree.setCheckedKeys(this.selectedOrgs,true);
						//this.$refs.orgtree.setCheckedNodes(this.selectedOrgs);
					}
				})
			},
			goSysRoleDetail(idx,row){
				this.detailTitle = '角色详情'
				this.isadd = false
				console.log(idx,row)
				this.selectset = JSON.parse(JSON.stringify(this.sysRoleList[idx]))
				this.detailShow = true
			},
			deleteRoleDetail(idx,row){
				this.$confirm('此操作将删除角色 '+this.sysRoleList[idx].name+', 是否继续?', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					deleteSysRole({
						rid : this.sysRoleList[idx].id
					}).then(res => {
						if(0 == res.code){
							this.queryRoleList()
							this.$message({
								showClose: true,
								message: "删除成功",
								type: 'success'
							});
						}else{
							this.$message({
								showClose: true,
								message: res.message,
								type: 'error'
							});
						}
					})
				}).catch(() => {
					console.log("取消")
				});
			},
			addRole(){
				this.detailTitle = "新增用户"
				this.isadd = true
				this.selectset = null
				this.detailShow = true
			},
			needRefrash(val,isshow){
				this.editok = val
				this.detailShow = isshow
			},
			refrashData() {
				if(this.editok){
					this.queryRoleList()
				}
			},
			saveRoleOrgs(){
				//console.log(this.$refs.orgtree.getCheckedNodes());
				let orgnodes = this.$refs.orgtree.getCheckedNodes();
				if(orgnodes.length > 0){
					let param = []
					let checkok = true
					let msg = ''
					orgnodes.forEach((it) => {
						let ty = []
						if(it.cancontroll == true){
							ty.push("control")
						}
						if(it.canread == true){
							ty.push("read")
						}
						if(it.canset == true){
							ty.push("set")
						}
						if(ty.length == 0){
							checkok = false
							msg += it.name + '没有勾选权限;'
						}else{
							param.push({
								roleid: this.selectedroleid,
								orgid : it.id,
								type : ty.join(",")
							})
						}
					})
					if(!checkok){
						this.$message({
							showClose: true,
							message: msg,
							type: 'warning'
						});
					}else{
						updateSysRoleOrgs(param).then(res => {
							if(0 == res.code){
								this.$message({
									showClose: true,
									message: "更新成功",
									type: 'success'
								});
							}else{
								this.$message({
									showClose: true,
									message: res.message,
									type: 'error'
								});
							}
						})
					}
				}else{
					this.$message({
						showClose: true,
						message: '请选择组织',
						type: 'warning'
					});
				}
			},
			saveRoleMenus(){
				if(this.selectedroleid == null || this.selectedroleid == ''){
					this.$message({
						showClose: true,
						message: '请先选择角色',
						type: 'warning'
					});
					return;
				}
				console.log(this.$refs.menutree.getCheckedKeys());
				let menuids = this.$refs.menutree.getCheckedKeys();
				if(menuids.length > 0){
					let param = []
					menuids.forEach((item) => {
						param.push({
							roleid : this.selectedroleid,
							menuid : item
						})
					})
					updateSysRoleMenus(param).then(res => {
						if(0 == res.code){
							this.$message({
								showClose: true,
								message: "更新成功",
								type: 'success'
							});
						}else{
							this.$message({
								showClose: true,
								message: res.message,
								type: 'error'
							});
						}
					})
				}else{
					this.$message({
						showClose: true,
						message: '请选择菜单',
						type: 'warning'
					});
				}
			},
			
		},
		beforeDestroy() {
			
		},
	}
</script>

<style scoped>
	.custom-tree-node {
	    flex: 1;
	    display: flex;
	    align-items: center;
	    justify-content: space-between;
	    font-size: 14px;
	    padding-right: 8px;
	  }
</style>